import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Explains the wait on a save that recomputes the clarity score.
 *
 * The score is analysed server-side before the record is written, so a save is never instant. With
 * only a spinner on the button, a wait of several seconds reads as a hung screen and people walk
 * away from a save that is still running. Naming the work sets the expectation instead.
 */
const ClaritySavingHint: React.FC<{ visible: boolean; className?: string }> = ({ visible, className }) => {
  const { t } = useTranslation();
  if (!visible) return null;

  return (
    <p
      role="status"
      aria-live="polite"
      data-testid="clarity-saving-hint"
      className={`text-xs text-muted-foreground ${className ?? ''}`}
    >
      {t('clarity.savingHint')}
    </p>
  );
};

export default ClaritySavingHint;
